import type { SectionDefinition, SectionName } from "./musicTypes";

/**
 * Phase 1A section set.
 *
 * Lengths are ranges, not constants: a fixed 8- or 16-bar cycle is exactly the
 * "looping" impression the project is trying to avoid. The actual length is
 * drawn from the seeded section stream.
 *
 * The offsets modulate the user's Energy/Density rather than overriding them,
 * so the sliders always remain in charge.
 */
export const SECTION_DEFINITIONS: Record<SectionName, SectionDefinition> = {
  intro: {
    minBars: 6,
    maxBars: 14,
    energyOffset: -0.18,
    densityOffset: -0.2,
    allowedNext: [
      { section: "establish", weight: 8 },
      { section: "develop", weight: 2 },
    ],
  },
  establish: {
    minBars: 10,
    maxBars: 22,
    energyOffset: 0,
    densityOffset: 0,
    allowedNext: [
      { section: "develop", weight: 7 },
      { section: "break", weight: 2 },
      { section: "release", weight: 1 },
    ],
  },
  develop: {
    minBars: 12,
    maxBars: 28,
    energyOffset: 0.12,
    densityOffset: 0.14,
    allowedNext: [
      { section: "break", weight: 4 },
      { section: "establish", weight: 3 },
      { section: "release", weight: 3 },
    ],
  },
  break: {
    // Short by nature: a break that outstays its welcome stops being a break.
    minBars: 4,
    maxBars: 9,
    energyOffset: -0.25,
    densityOffset: -0.3,
    allowedNext: [
      // After a break the music should feel like it returns, so establish and
      // develop dominate; another break immediately is not offered at all.
      { section: "develop", weight: 6 },
      { section: "establish", weight: 4 },
    ],
  },
  release: {
    minBars: 8,
    maxBars: 18,
    energyOffset: -0.12,
    densityOffset: -0.1,
    allowedNext: [
      { section: "establish", weight: 5 },
      { section: "intro", weight: 2 },
      { section: "develop", weight: 3 },
    ],
  },
};

export const INITIAL_SECTION: SectionName = "intro";
